import { render, staticRenderFns } from "./tradingdistribution.vue?vue&type=template&id=3f89666a&"
import script from "./tradingdistribution.vue?vue&type=script&lang=js&"
export * from "./tradingdistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports